export default {
  customDashboard: {
    loading: 'Loading...',
    loadingData: 'Loading data...',
    selectedSensors: '{count} selected sensors',
    addNewChart: 'Add new chart',
    chartTitle: 'Chart title',
    selectSensors: 'Select sensors',
    selectSensorValidation: 'Select at least one sensor',
    chartType: 'Chart type',
    selectChartType: 'Select a chart type',
    startDate: 'Start date',
    endDate: 'End date',
    invalidDateRange: 'Invalid date range',
    sensorColors: 'Sensor colors',
    others: 'others',
    buttons: {
      cancel: 'Cancel',
      confirm: 'Confirm',
      update: 'Update'
    },
    editChart: 'Edit chart',
    buttonColors: {
      green: '{sensorName} - Green',
      yellow: '{sensorName} - Yellow',
      red: '{sensorName} - Red'
    },
    selectDateRange: 'Select Date Range',
    quickFilters: 'Quick Filters',
    weeklyConsumption: 'Weekly Consumption',
    dataManager: 'Data Manager',
    lastRefilling: 'Last Refilling',
    dispenserLevel: 'Dispenser Level',
    time: 'Time',
    levelStatus: 'Level Status',
    fullEmptyDispenser: 'Full/Empty Dispenser',
    emptyHours: 'Empty Hours',
    consumptions: 'Consumptions',
    downloadChartData: 'Download Chart Data',
    downloadAllData: 'Download All Data',
    addNewWidget: 'Add new widget',
    widgetType: 'Widget type',
    chartTemplate: 'Chart template',
    comparisonLevel: 'Comparison level',
    entitiesToCompare: 'Entities to compare',
    period: 'Period',
    widgetTitle: 'Widget title',
    size: 'Size',
    filters: {
      title: 'Filters',
      clients: 'Clients',
      buildings: 'Buildings',
      floors: 'Floors',
      areas: 'Areas',
      dispenserType: 'Dispenser Type',
      productType: 'Product Type',
      selectAll: 'Select all',
      deselectAll: 'Deselect all'
    },
    sizes: {
      small: 'Small',
      medium: 'Medium',
      large: 'Large'
    },
    kpiType: 'KPI type',
    dataLevel: 'Data level',
    articleType: 'Article type',
    edit: 'Edit',
    delete: 'Delete',
    kpiTypes: {
      totalConsumption: {
        title: 'Total Paper Consumption',
        description: 'Total paper used in the selected time range'
      },
      averageDaily: {
        title: 'Average Daily Consumption',
        description: 'Average paper consumption per day'
      },
      mostUsedArticle: {
        title: 'Most Used Article',
        description: 'Most used paper type by percentage'
      },
      inactiveZones: {
        title: 'Inactive Zones',
        description: 'Number of areas with no activity during the selected time range'
      },
      estimatedCost: {
        title: 'Estimated Paper Cost',
        description: 'Estimated cost of paper used in the selected time range'
      },
      peakUsageDay: {
        title: 'Peak Usage Day',
        description: 'The day with the highest usage during the selected time range'
      }
    },
    chartTypes: {
      paperConsumption: {
        title: 'Paper Consumption',
        description: 'Compare total paper usage'
      },
      usageFrequency: {
        title: 'Usage Frequency',
        description: 'Compare how often areas are used'
      },
      paperCost: {
        title: 'Paper Cost',
        description: 'Compare estimated costs of paper usage'
      },
      alertEvents: {
        title: 'Alert Events',
        description: 'Compare how many alert events occurred'
      },
      consumptionVsFrequency: {
        title: 'Consumption vs Frequency',
        description: 'Compare daily usage frequency with paper consumption for a selected area'
      },
      sensorComparison: {
        title: 'Sensor Comparison',
        description: 'Compare historical data between selected sensors'
      },
      consumptionVsBathroom: {
        title: 'Consumption vs Bathroom Usage',
        description: 'Correlation between paper consumption and bathroom usage frequency'
      }
    },
    sensorCategories: {
      dispenser: 'Dispenser',
      doors: 'Doors'
    },
    sensorComparison: {
      title: 'Sensor Comparison',
      selectSensors: 'Select sensors to compare',
      selectCategory: 'Select category',
      noSensorsSelected: 'Select at least one sensor for comparison',
      loading: 'Loading sensor data...'
    }
  },
  sensor: {
    error: {
      loading: 'Error loading sensor details',
      updating: 'Error updating sensor',
      requiredFields: 'Please fill in all required fields',
      title: 'Error',
      emptyFields: 'The following fields are required: {fields}',
      duplicateDevEui: 'This Sensor ID already exists in the system',
      duplicateDevEuiHint: 'The entered Sensor ID is already associated with another sensor. Please enter a unique ID.',
      creation: 'Error creating sensor',
      creating: 'Error while creating sensor',
      checkingExistence: 'Error while checking sensor',
    },
    add: {
      title: 'SENSOR QUICK SETUP : Please fill the fields below'
    },
    duplicate: {
      title: 'DUPLICATE SENSOR CONFIGURATION: Please fill the fields below'
    },
    fields: {
      sensorId: 'Sensor ID',
      dispenserName: 'Dispenser Name',
      dispenserBrand: 'Dispenser Brand',
      dispenserArticleCode: 'Dispenser Article Code',
      consumableBrand: 'Consumable Brand',
      consumableArticleCode: 'Consumable Article Code',
      client: 'Client',
      building: 'Building',
      floor: 'Floor',
      area: 'Area',
      maxSheets: 'Max N. of sheets',
      maxValue: 'Max Value - Empty Dispenser distance (mm)',
      minValue: 'Min Value - Full Dispenser distance (mm)',
      buttonType: 'Button Type'
    },
    selectDispenser: 'Select Dispenser',
    notManagedYet: 'Not managed yet',
    emptyHours: 'Empty Hours',
    full: 'Full',
    empty: 'Empty'
  },
  login: {
    title: 'Login',
    button: 'Login',
    username: 'Username',
    password: 'Password',
    error: 'Incorrect username or password!',
    close: 'Close',
    forgotPassword: 'Forgot Password',
    resetPassword: 'Reset Password',
    resetPasswordInstructions: 'Please enter the email used during the registration',
    email: 'Email',
    resetRequested: 'Reset requested for:',
    enterNewPassword: 'Enter your new password in the fields below (make sure both password are the same in order to proceed)',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    passwordsDontMatch: 'The passwords don\'t match'
  },
  KEY001: 'Login',
  key006: 'Incorrect username or password!',
  key007: 'Close',
  validation: {
    required: 'This field is required',
    duplicateDevEui: 'This Sensor ID already exists'
  },
  building: {
    add: {
      title: 'CREATE A NEW BUILDING : Please fill the fields below'
    },
    fields: {
      name: 'Building name',
      address: 'Building address'
    },
    error: {
      creation: 'Error creating building'
    }
  },
  floor: {
    add: {
      title: 'CREATE A NEW FLOOR : Please fill the fields below'
    },
    fields: {
      name: 'Floor name',
      building: 'Building'
    },
    error: {
      creation: 'Error creating floor'
    }
  },
  area: {
    add: {
      title: 'CREATE A NEW AREA : Please fill the fields below'
    },
    fields: {
      name: 'Area name',
      building: 'Building',
      floor: 'Floor'
    },
    error: {
      creation: 'Error creating area'
    }
  },
  washroomFrequency: {
    selectSensor: 'Select one washroom sensor to continue',
    loading: 'Loading...',
    client: 'Client',
    building: 'Building',
    floor: 'Floor',
    area: 'Area',
    sensor: 'Sensor',
    back: 'BACK',
    ok: 'OK',
    quickFilters: 'Quick filters:',
    hours: '4 HOURS',
    day: '1 DAY',
    week: '1 WEEK',
    twoWeeks: '2 WEEKS',
    thirtyDays: '30 DAYS',
    selectDateRange: 'Select date range',
    cancel: 'Cancel',
    trafficOverview: 'TRAFFIC OVERVIEW',
    currentTraffic: 'CURRENT TRAFFIC',
    name: 'Name:',
    sensorType: 'Sensor Type:',
    sensorTypes: {
      'People Counter': 'People Counter',
      'Occupancy (PIR)': 'Occupancy (PIR)',
      'Door Counter': 'Door Counter'
    },
    lastCleaning: 'Last Cleaning:',
    averageAlertsNo: 'Average Alerts N°:',
    averageDailyTraffic: 'Average Traffic<br>(selected period):',
    averageDailyAlertsPeriod: 'Average Daily Alerts<br>(selected period):',
    dailyTraffic: 'Daily Traffic:',
    time: 'Time:',
    cleaningStatus: 'Cleaning Status',
    alertThreshold: 'Alert Threshold:',
    currentTrafficValue: 'Current Traffic',
    dataManager: 'DATA MANAGER',
    sensorName: 'Sensor name:',
    cleaningSchedule: 'CLEANING SCHEDULE',
    washroomUsageFrequency: 'WASHROOM USAGE FREQUENCY',
    usageWithAlerts: 'USAGE WITH/WITHOUT ALERT ON PAGE',
    events: 'Events',
    cleaningRequired: 'Cleaning Required',
    mightNeedClean: 'Might need clean',
    doesntNeedClean: "Doesn't need clean",
    usageByDaytime: 'USAGE BY DAYTIME PERIOD',
    morning: 'Morning (00:00 - 12:00)',
    afternoon: 'Afternoon (12:00 - 24:00)',
    usageByFourHourly: 'USAGE BY 4-HOUR PERIODS',
    b1: 'B1 (00–04)',
    b2: 'B2 (04–08)',
    b3: 'B3 (08–12)',
    b4: 'B4 (12–16)',
    b5: 'B5 (16–20)',
    b6: 'B6 (20–24)',
    trafficVolumeVsAlert: 'TRAFFIC VOLUME VS. ALERT STATUS',
    normalTraffic: 'Normal Traffic',
    trafficDuringAlert: 'Traffic during Alert',
    eventToAlert: 'Events to Alert',
    eventTriggered: 'Registered Traffic',
    serviceEfficiencyTimeline: 'CLEANING EFFICIENCY ANALYSIS',
    responseTime: 'Response Time',
    cleaned: 'Cleaned',
    alert: 'Alert',
    sensorOverview: 'Sensor Overview',
    online: 'Online',
    offline: 'Offline',
    lastDataReceivedLabel: 'Last Data Received',
    lastCleaningLabel: 'Last Cleaning',
    alertThresholdLabel: 'Alert Threshold',
    currentTrafficTitle: 'Current Traffic',
    aboveThreshold: 'Above threshold',
    belowThreshold: 'Below threshold',
    live: 'Live',
    trafficLegend: 'Traffic',
    thresholdLegend: 'Threshold',
    remainingRange: 'Remaining range',
    thresholdLabel: 'Threshold',
    entriesUnit: 'entries',
    avgDailyTrafficKpi: 'Avg Daily Traffic',
    averageEntriesPerDay: 'Average entries per day',
    peakTrafficWindow: 'Peak Traffic Window',
    avgDailyCleaningActivities: 'Avg Daily Cleaning Activities',
    validatedOperationsPerDay: 'Validated operations per day',
    avgTrafficPerCleaning: 'Avg Traffic per Cleaning',
    entriesPerCleaning: 'Entries managed per cleaning',
    avgDailyAlertsKpi: 'Avg Daily Alerts',
    thresholdExceedancesPerDay: 'Threshold exceedances per day',
    avgActiveHoursPerDay: 'Avg Active Hours / Day',
    hoursWithRecordedTraffic: 'Hours with recorded traffic'
  },
  manageSensors: {
    title: 'Manage Sensors',
    addNewSensor: 'Add new sensor',
    sensorDeleting: 'Sensor Deleting',
    deleteConfirm: 'Are you sure you want to delete "{name}"?',
    client: 'Client',
    building: 'Building',
    floor: 'Floor',
    area: 'Area',
    sensor: 'Sensor',
    clearFilter: 'Clear filter',
    filter: 'Filter',
    type: 'Type',
    fillLevel: 'Fill level',
    liveUsage: 'Live usage',
    cleaningLimit: 'Cleaning Threshold',
    name: 'Name',
    company: 'Company',
    battery: 'Battery',
    sensorId: 'Sensor ID',
    actions: 'Actions',
    tooltips: {
      edit: 'Edit sensor',
      duplicate: 'Duplicate sensor',
      delete: 'Delete sensor'
    },
    buttonSubtypes: {
      feedback: 'Feedback',
      click: 'Service',
      RFID: 'RFID Validation',
      display: 'Panel',
      RFID_BUTTON: 'RFID Button'
    },
    dispenserSubtypes: {
      foldedHandTowels: 'Folded Hand Towels',
      handTowelRolls: 'Hand Towel Rolls',
      foldedToiletPaper: 'Folded Toilet Paper',
      toiletPaperRolls: 'Toilet Paper Rolls',
      soap: 'Soap'
    },
    editSensor: 'EDIT SENSOR',
    update: 'Update',
    noDataAvailable: 'No data available'
  },
  alerts: {
    title: 'Alerts',
    alertTime: 'ALERT TIME',
    solvedTime: 'SOLVED TIME',
    message: 'MESSAGE',
    markAsDone: 'Mark as done',
    triggerAt: 'Trigger at',
    resolvedAt: 'Resolved at',
    duration: 'Duration',
    confirmResolve: 'Confirm Alert Resolution',
    confirmResolveMessage: 'Are you sure you want to mark this alert as {status}?',
    resolved: 'resolved',
    unresolved: 'unresolved',
    sensorDetails: 'Sensor Details',
    sensorName: 'Sensor Name',
    building: 'Building',
    floor: 'Floor',
    area: 'Area',
    triggeredAt: 'Triggered at',
    receivedAt: 'Received at',
    status: 'Status',
    currentStatus: 'Current Status',
    confirm: 'Confirm',
    cancel: 'Cancel',
    action: 'Action'
  },
  dashboard: {
    title: 'Dashboard',
    overview: 'Overview',
    statistics: 'Statistics',
    editWidget: 'Edit Widget',
    addWidget: 'Add Widget',
    widgetSize: 'Widget Size',
    size: 'Size',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    sizes: {
      small: 'Small',
      smallDesc: '1/4 width - Compact widgets',
      medium: 'Medium',
      mediumDesc: '1/2 width - Standard widgets',
      large: 'Large',
      largeDesc: 'Full width - Large widgets'
    },
    addNewWidget: 'Add new widget',
    kpiWidget: 'KPI Widget',
    configureKpiWidget: 'Configure KPI Widget',
    widgetTitle: 'Widget Title',
    dataLevel: 'Data Level',
    selectClient: 'Select Client',
    selectClients: 'Select Clients',
    selectBuilding: 'Select Building',
    selectBuildings: 'Select Buildings',
    selectFloor: 'Select Floor',
    selectFloors: 'Select Floors',
    selectArea: 'Select Area',
    selectAreas: 'Select Areas',
    selectSensor: 'Select Sensor',
    selectSensors: 'Select Sensors',
    selectEntity: 'Select Entity',
    selectPeriod: 'Select Period',
    customPeriod: 'Custom Period',
    selectDateRange: 'Select Date Range',
    startDate: 'Start Date',
    endDate: 'End Date',
    client: 'Client',
    building: 'Building',
    floor: 'Floor',
    area: 'Area',
    sensor: 'Sensor',
    entitiesToCompare: 'Entities to Compare',
    kpiTypes: {
      restroomDailyUsage: {
        title: 'Area Daily Usage – Avg / Day',
        description: 'Shows the average daily entries per monitored area during the selected period.'
      },
      usageFrequencyComparison: {
        title: 'Usage Frequency Comparison',
        description: 'Compare usage trends over time across selected areas to identify peak activity periods.'
      },
      dispenserFillHeatmap: {
        title: 'Heatmap Dispenser Fill Level',
        description: 'Shows the average fill level of dispensers across daily time slots for the selected area.',
        tableTitle: 'Heatmap Dispenser Fill Level',
        tableSubtitle: 'Average fill level percentage within the selected period.',
        colLocation: 'Dispenser & Area Location'
      },
      dispenserConsumptionAnalysis: {
        title: 'Consumption by Dispenser Model',
        description: 'Compares consumables usage by dispenser model, location and visits within the selected period.'
      }
    },
    dispenserConsumptionAnalysis: {
      tableTitle: 'Consumable Analysis by Dispenser',
      tableSubtitle: 'Compares consumables usage by dispenser, location and visits within the selected period.',
      unitRolls: 'UNIT: ROLLS',
      unitLiters: 'UNIT: LITERS',
      unitSheets: 'UNIT: SHEETS',
      groupHandTowelRoll: 'Paper Towel Rolls',
      groupFoldedTowels: 'Folded Towels',
      groupToiletPaperRolls: 'Toilet Paper Rolls',
      groupFoldedToiletPaper: 'Folded Toilet Paper',
      groupSoap: 'Soap',
      groupTotal: 'GROUP TOTAL',
      colDispenser: 'DISPENSER',
      colLocation: 'LOCATION',
      colTotalConsumption: 'TOTAL CONSUMPTION',
      colAvgPerDay: 'AVG / DAY',
      colConsPer100Visits: 'CONS. / 100 VISITS'
    },
    periodOptions: {
      lastDay: 'Last Day',
      last7Days: 'Last 7 days',
      last14Days: 'Last 14 days',
      last30Days: 'Last 30 days',
      customPeriod: 'Custom Period'
    },
    validation: {
      startDateRequired: 'Start date is required',
      endDateRequired: 'End date is required',
      endDateAfterStart: 'End date must be after start date',
      futureDateNotAllowed: 'End date cannot be in the future. Please select up to yesterday.',
      startDateTooOld: 'Start date cannot be more than 30 days ago. Please select a more recent date.',
      endDateBeforeStart: 'End date must be after start date.',
      periodTooShort: 'Period must be at least 1 day.',
      periodTooLong: 'Period selected ({days} days). Consider shorter periods for optimal performance.',
      validPeriod: 'Valid period selected ({days} days).'
    },
    periodInfo: {
      period: 'Period',
      upTo: 'Up to',
      dataFrom: 'Data from',
      lastDay: 'Data from yesterday ({date}) - Up to {date}',
      last7Days: 'Data from last 7 days - Up to {date}',
      last14Days: 'Data from last 14 days - Up to {date}',
      last30Days: 'Data from last 30 days - Up to {date}',
      customRange: 'Custom period: {start} to {end} - Up to {end}',
      selectCustomRange: 'Select custom date range - Up to {date}'
    },
    tableHeaders: {
      article: 'Article',
      device: 'Device',
      location: 'Location',
      packsUsed: 'Packs Used',
      refillsPerDay: 'Refills / Day',
      restroom: 'Restroom',
      restroomAndLocation: 'Restroom & Location',
      avgEntriesPerDay: 'Avg Entries / Day',
      status: 'Status',
      dailyPattern: 'Daily Pattern (AM vs PM)',
      avgAlertsPerDay: 'Avg alerts / day',
      trendVsPrevious: '▲ vs previous period',
      trendVsLastWeek: 'Trend vs Previous Period',
      deltaVsPrevious: 'Δ vs prev.',
      client: 'Client',
      building: 'Building',
      floor: 'Floor',
      area: 'Area',
      dispenser: 'Dispenser',
      item: 'Item',
      value: 'Value'
    },
    status: {
      low: 'Low',
      empty: 'Empty',
      normal: 'Normal',
      active: 'Active'
    },
    summary: {
      clientsSelected: '{count} Clients selected',
      buildingsSelected: '{count} Buildings - {floors} Floors - {sensors} Dispensers selected',
      floorsSelected: '{building} - {count} Floors selected',
      clients: '{count} Clients',
      buildings: '{count} Buildings',
      floors: '{count} Floors',
      areas: '{count} Areas',
      sensors: '{count} Sensors',
      selected: 'selected'
    },
    selectAll: 'Select All',
    restroomUsageSensorLevelOnly: 'This KPI requires sensor-level selection. Navigate through Client > Building > Floor > Area to select specific sensors.'
  },
  alertsManagement: {
    pageTitle: 'Alerts Management',
    createRule: 'Create new rule',
    addNewAlert: 'Add New Alert',
    fillFields: 'Please, fill the fields below',
    title: 'Title',
    alertName: 'ALERT NAME',
    email: 'email (use ; to separate emails)',
    emailLabel: 'Email (use ; to separate emails)',
    customMessage: 'Insert your custom message here:',
    alertValue: 'Alert Value (%) - n. of events',
    saveRule: 'Save rule',
    sensor: 'SENSOR',
    emailAddresses: 'EMAIL ADDRESSES',
    recipients: 'RECIPIENTS',
    active: 'ACTIVE',
    status: 'STATUS',
    phoneNumbers: 'PHONE NUMBERS',
    airField: 'Field to Monitor',
    comparisonOperator: 'Comparison Operator',
    airFields: {
      pressure: 'Pressure',
      co2: 'CO2',
      temperature: 'Temperature',
      humidity: 'Humidity'
    },
    buttonField: 'Press Type',
    buttonFields: {
      short: 'Short',
      long: 'Long',
      double: 'Double'
    },
    operators: {
      greaterThan: 'Greater than (>)',
      lessThan: 'Less than (<)'
    },
    deleteConfirm: {
      title: 'Confirm Deletion',
      message: 'Are you sure you want to delete the rule "{title}"?',
      description: 'This action cannot be undone.'
    }
  },
  users: {
    title: 'Users',
    manageUser: 'Manage User',
    username: 'USERNAME',
    role: 'ROLE',
    active: 'ACTIVE',
    changePassword: 'Change Password',
    changePasswordTitle: 'Fill the fields below to change your password',
    oldPassword: 'Old password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    passwordMinLength: 'Password must be at least 6 characters long',
    passwordMismatch: 'Passwords do not match',
    passwordChangedSuccess: 'Password changed successfully',
    passwordChangeError: 'An error occurred saving your new password. Please try again or contact the support team.'
  },
  buildings: {
    title: 'Buildings',
    name: 'Name',
    address: 'Address',
    sensors: 'Sensors'
  },
  smartDispenser: {
    selectSensor: 'Select one smart dispenser to continue',
    loading: 'Loading...',
    quickFilters: 'Quick filters:',
    hours: '4 HOURS',
    day: '1 DAY',
    threeDays: '3 DAYS',
    week: '1 WEEK',
    twoWeeks: '2 WEEKS',
    lastMonth: 'LAST MONTH',
    selectDateRange: 'Select date range',
    dataManager: 'DATA MANAGER',
    sensorName: 'Sensor name:',
    lastRefill: 'Last refilling:',
    consumption: 'Consumption:',
    binLevel: 'BIN LEVEL',
    dispenserLevel: 'DISPENSER LEVEL',
    dispenserAvailability: 'DISPENSER AVAILABILITY – % FULL vs EMPTY',
    dispenserDowntime: 'DISPENSER DOWNTIME – EMPTY HOURS / DAY',
    consumptions: 'CONSUMPTIONS',
    units: {
      sheets: 'sheets',
      milliliters: 'milliliters',
      rolls: 'rolls'
    },
    downloadChartData: 'Download chart data',
    downloadAllData: 'Download all sensor data',
    refillSchedule: 'REFILL SCHEDULE',
    levelStatus: 'Level status:',
    time: 'Time:',
    status: {
      offline: 'Offline - No data received today',
      needsRefill: 'Empty - Refill required',
      lowLevel: 'Low level - May need refill soon',
      full: 'OK - Dispenser is full'
    },
    dispenserOverview: 'Dispenser Overview',
    online: 'Online',
    offline: 'Offline',
    lastDataReceived: 'Last Data Received',
    refillThreshold: 'Refill Threshold',
    currentLevel: 'Current level',
    currentCapacity: 'Current capacity',
    belowRefillThreshold: 'Below refill threshold',
    aboveRefillThreshold: 'Above refill threshold',
    live: 'Live',
    availableLevel: 'Available level',
    threshold: 'Threshold',
    remainingCapacity: 'Remaining capacity',
    dispenserType: 'Dispenser type',
    avgDailyConsumption: 'Avg Daily Consumption',
    sheetsUsedPerDay: 'Sheets used per day',
    rollsUsedPerDay: 'Rolls used per day',
    mlUsedPerDay: 'ml used per day',
    avgDailyFillLevel: 'Avg Daily Fill Level',
    averageDispenserLevel: 'Average dispenser level',
    avgRefillInterval: 'Avg Refill Interval',
    daysBetweenRefills: 'Days between refills',
    avgDailyEmptyHours: 'Avg Daily Empty Hours',
    downtimePerDay: 'Downtime per day',
    avgDailyAvailability: 'Avg Daily Availability',
    timeAboveEmptyLevel: 'Time above empty level',
    avgLevelAtRefill: 'Avg Level at Refill',
    levelWhenRefillHappens: 'Level when refill happens',
    includeWeekends: 'Include weekends',
    selectedPeriod: 'Selected period',
    clearFilter: 'Clear filter',
    notAvailable: 'N/A'
  },
  smartBin: {
    selectSensor: 'Select one smart bin to continue',
    binLevel: 'BIN LEVEL',
    binFillLevel: 'BIN FILL LEVEL – LEVEL',
    averageFillingLevel: 'AVERAGE FILLING LEVEL',
    fillLevel: 'Fill Level'
  },
  airQuality: {
    selectSensor: 'Select one air quality sensor to continue',
    co2Level: 'CO2 LEVEL',
    temperature: 'TEMPERATURE',
    humidity: 'HUMIDITY',
    averageCo2: 'AVERAGE CO2 LEVEL'
  },
  sensorDetails: {
    sensorDetails: 'Sensor Details',
    deviceInfo: 'Device Information',
    location: 'Location',
    status: 'Status',
    lastUpdate: 'Last Update'
  },
  cleaningLog: {
    title: 'Cleaning Log',
    time: 'Cleaned at',
    date: 'Date',
    location: 'Location',
    operator: 'Operator',
    trigger: 'Trigger',
    responseTime: 'Reaction from alert',
    trafficHandled: 'Traffic since last clean',
    searchOperator: 'Search operator',
    searchOperatorPlaceholder: 'Name or badge ID...',
    noDataAvailable: 'No cleaning interventions available',
    alert: 'Alert',
    routine: 'Routine',
    download: 'Download',
    downloadTooltip: 'Download Excel',
    quickFilters: 'Quick filters:',
    timeSinceLastCleaning: 'Time since last clean',
    selectDateRange: 'Select date range',
    today: 'Today',
    last7Days: '7 days',
    last14Days: '14 days',
    last30Days: '30 days',
    allPeriod: 'All',
    sensorOverview: 'Sensor Overview',
    totalCleanings: 'Total Cleanings',
    lastCleaning: 'Last Cleaning',
    avgTraffic: 'Avg Traffic',
    periodSummary: 'Period Summary',
    alertTriggered: 'Alert Triggered',
    routineTriggered: 'Routine',
    totalTraffic: 'Total Traffic',
    avgResponseTime: 'Avg Response Time'
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    ok: 'OK',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    continue: 'Continue',
    update: 'Update',
    search: 'Search',
    loading: 'Loading...',
    noDataAvailable: 'No data available',
    noDevicesConnected: 'No devices connected yet',
    yes: 'Yes',
    no: 'No',
    error: 'Error',
    saveChanges: 'Save Changes',
    others: 'others',
    itemsPerPage: 'Items per page',
    all: 'All',
    of: 'of',
    days: {
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday'
    }
  },
  dashboardsView: {
    selectOneOrMore: 'Select one or more sensor',
    selectOne: 'Select one sensor',
    selectBin: 'Select one or more Bin',
    selectDispenser: 'Select one or more dispenser',
    toiletPaper: 'Toilet Paper',
    rolls: 'N° rolls',
    foldedTowels: 'Folded Towels',
    sheets: 'N° sheets',
    cartons: 'N° Cartons',
    washroomFreq: 'Washroom Freq.',
    dailyAverage: 'Daily Average',
    binWasteLevel: 'BIN WASTE LEVEL',
    fullEmptyDispenser: 'FULL - EMPTY DISPENSER',
    washroomUsageFrequency: 'WASHROOM USAGE FREQUENCY',
    dispenserLevel1Floor: 'DISPENSER LEVEL - 1 FLOOR',
    paperConsumption: 'PAPER CONSUMPTION',
    emptyDispenserEvent: 'EMPTY DISPENSER EVENT'
  },

  cleaningEfficiency: {
    title: 'Area Cleaning Efficiency',
    loading: 'Loading...',
    client: 'Client',
    building: 'Building',
    floor: 'Floor',
    area: 'Area',
    dateRange: 'Date Range',
    includeWeekends: 'Include Weekends',
    clearFilter: 'Clear filter',
    quickFilters: 'Quick filters:',
    last4Hours: '4 Hours',
    lastDay: '1 Day',
    lastWeek: '1 Week',
    last2Weeks: '2 Weeks',
    last30Days: '30 Days',
    deviceOverview: 'Device Overview',
    online: 'Online',
    offline: 'Offline',
    lastDataReceived: 'Last Data Received',
    lastCleaning: 'Last Cleaning',
    managedSensors: 'Managed Sensors',
    cleaningType: 'Cleaning type',
    currentAreaStatus: 'Current Area Status',
    areaRecentlyCleaned: 'Area recently cleaned',
    live: 'Live',
    entriesSinceLastCleaning: 'Entries since last cleaning',
    trafficSinceLastCleaning: 'Traffic since last cleaning',
    remainingRange: 'Remaining range',
    threshold: 'Threshold',
    avgReactionTime: 'Avg Reaction Time',
    avgDailyCleans: 'Avg Daily Cleans',
    avgDailyAlerts: 'Avg Daily Alerts',
    avgManagedTraffic: 'Avg Managed Traffic',
    avgDailyAreaEntries: 'Avg Daily Area Entries',
    avgTimeBetweenCleanings: 'Avg Time Between Cleanings',
    reactionTimeDesc: 'Response time from alert to cleaning',
    cleaningsPerDay: 'Cleanings per day',
    alertsPerDay: 'Threshold exceedances per day',
    managedTrafficDesc: 'Average entries managed per cleaning',
    managedEntries: 'Managed Entries',
    areaSensors: 'Area Sensors',
    associatedSensors: 'associated sensors',
    entriesSinceLastCleaningLabel: 'entries since last cleaning',
    type: 'Type',
    name: 'Name',
    liveUsage: 'Live Usage',
    cleaningThreshold: 'Cleaning Threshold',
    avgDailyEntries: 'Avg Daily Entries',
    avgDailyEntriesDesc: 'Average daily entries generated by each sensor in the managed area.',
    dailyEfficiencyChart: 'Daily Efficiency & Traffic',
    cumulativeTraffic: 'Cumulative Traffic',
    alert: 'Alert',
    rfidClean: 'RFID Clean',
    alertThreshold: 'Alert threshold',
    noDataAvailable: 'No data available for the selected period.',
    selectAreaToLoad: 'Select a client, building, floor and area to load data.',
  },
} 